const version = "2025.1.0";
export {
  version
};
//# sourceMappingURL=package.json.mjs.map
